/**
 * DPos
 * API for DPos
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Merchant } from './merchant';


export interface FileUpload { 
    batchId?: string;
    createdByName?: string;
    creationTime?: string;
    deleted?: boolean;
    errorMessage?: string;
    fileName?: string;
    fileUploadStatusEnum?: FileUpload.FileUploadStatusEnumEnum;
    id?: number;
    merchant?: Merchant;
    percentage?: number;
    rowNo?: number;
    updateTime?: string;
    updatedByName?: string;
}
export namespace FileUpload {
    export type FileUploadStatusEnumEnum = 'FAIL' | 'IN_PROGRESS' | 'NEW' | 'REVERT' | 'SUCCESS';
    export const FileUploadStatusEnumEnum = {
        Fail: 'FAIL' as FileUploadStatusEnumEnum,
        InProgress: 'IN_PROGRESS' as FileUploadStatusEnumEnum,
        New: 'NEW' as FileUploadStatusEnumEnum,
        Revert: 'REVERT' as FileUploadStatusEnumEnum,
        Success: 'SUCCESS' as FileUploadStatusEnumEnum
    };
}


